/* unplugin-vue-components disabled */import script from "./svgIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./svgIcon.vue?vue&type=script&setup=true&lang=js"

import "./svgIcon.vue?vue&type=style&index=0&id=1d2e84bc&lang=scss"

const __exports__ = script;

export default __exports__